import React, { Component } from 'react'

import './css/zoom.css'

export default class Zoom extends Component {

  state = {
    visible : false,
    lensT   : 0,
    lensL   : 0,
    pageY   : 0,
    pageX   : 0,
    imageT  : 0,
    imageL  : 0,
    loaded  : false,
  }

  componentWillReceiveProps(props) {
    if (this.state.loaded) {
      this.largeImage.src = undefined
    }
    this.setState({loaded: false})
  }

  render() {
    return !(this.props.smallURL && this.props.largeURL && this.props.lensSize) ? '' : (
      <div
        ref       = {zoom => { this.zoom = zoom }}
        className = "zoom">
        <img
          ref         = {image => { this.smallImage = image }}
          src         = {this.props.smallURL} 
          alt         = {this.props.caption || this.props.title}
          onMouseOver = {this.showLens.bind(this)}
          onMouseOut  = {this.hideLens.bind(this)}
          onMouseMove = {this.updateLens.bind(this)}
          className   = "preview-image zoom-small"
        />
        <div
          className   = {`zoom-lens ${(this.largeImage && this.largeImage.offsetHeight === 0) && 'zoom-loading'}`}
          style       = {{
            visibility   : this.state.visible ? 'visible' : 'hidden',
            top          : this.state.lensT + 25 - this.props.lensSize,
            left         : this.state.lensL - 25,
            width        : this.props.lensSize,
            height       : this.props.lensSize,
            borderRadius : this.props.lensSize / 2,
          }}
        >
          <img
            ref       = {image => { this.largeImage = image }}
            src       = {this.props.largeURL}
            alt       = {this.props.caption || this.props.title}
            title     = {this.props.title || this.props.caption}
            onLoad    = {this.updateImage.bind(this)}
            className = "zoom-large"
            style     = {{
              top     : this.state.imageT + this.props.lensSize / 2,
              left    : this.state.imageL + this.props.lensSize / 2,
              display : this.state.loaded ? 'block' : 'none',
            }}
          />
        </div>
      </div>
    )
  }

  showLens(e) {
    this.setState({visible: true, lensT: e.clientY, lensL: e.clientX})
  }

  hideLens() {
    this.setState({visible: false})
  }

  updateLens(e) {
    this.setState({lensT: e.clientY, lensL: e.clientX, pageY: e.pageY, pageX: e.pageX}, () => this.state.loaded && this.updateImage())
  }

  updateImage() {
    let main = document.getElementById('main')
    let T = this.state.pageY - main.offsetTop  - this.zoom.offsetTop
    let L = this.state.pageX - main.offsetLeft - this.zoom.offsetLeft
    let R = this.largeImage.offsetHeight / this.smallImage.offsetHeight
    this.setState({loaded: true, imageT: -T*R, imageL: -L*R})
  }

}



// WEBPACK FOOTER //
// ./src/components/zoom.js